import React from "react";
import styled from "styled-components";

const PageWrapper = styled.div`
  max-width: 1000px;
  margin: 40px auto;
  padding: 20px;
  line-height: 1.8;
  color: #333;
  font-size: 16px;

  @media (max-width: 1024px) {
    max-width: 90%;
    font-size: 15px;
  }

  @media (max-width: 768px) {
    max-width: 95%;
    font-size: 14px;
    padding: 15px;
    line-height: 1.7;
  }

  @media (max-width: 480px) {
    font-size: 13px;
    padding: 12px;
    text-align: center;
    line-height: 1.6;
  }
`;

const Title = styled.h1`
  text-align: center;
  margin-bottom: 20px;
  background: linear-gradient(90deg, #ff512f, #dd2476);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 2rem;

  @media (max-width: 768px) {
    font-size: 1.6rem;
  }

  @media (max-width: 480px) {
    font-size: 1.4rem;
  }
`;
const Wrap = styled.div`
  background-color: #f9f9f9;
  min-height: 100vh;
  padding: 20px 0;
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
`;
export default function AffiliateDisclosure() {
  return (
    <Wrap>
    <PageWrapper>
      <Title>Affiliate Disclosure</Title>
      <p>
        <b>AttractDeals</b> is a participant in the Amazon Associates Program,
        an affiliate advertising program designed to provide a means for sites
        to earn advertising fees by linking to Amazon.com and its affiliated
        sites.
      </p>
      <p>
        This means when you click on our Amazon links and make a purchase, we
        may earn a small commission at no additional cost to you.
      </p>
      <p>
        We only recommend products that we believe add value to our readers.
        Your support through these purchases helps us continue providing
        updated deals and recommendations.
      </p>
    </PageWrapper>
    </Wrap>
  );
}
